const styles = {
  root: {
    display: "flex",
    borderRadius: '4px',
    backgroundColor: "#F4F4F7",
    padding: "10px 16px 10px 12px",
    gap: "8px",
    minHeight: '40px',
    width: "360px",
    maxWidth: "100%",
    marginRight: "4px",
  },
  container: {
    paddingBottom: { xs: "2px", sm: "2px" },
  },
  title: {
    color: "common.white",
  },
  subTitle: {
    color: "common.white",
    marginTop: "20px",
  },
  search: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "632px",
    borderRadius: "20px",
    margin: "32px auto",
  },
  searchIcon: {
    padding: "0",
    "& > img": {
      height: '20px',
      width: '20px'
    },
  },
  searchInput: {
    height: '22px',
    flex: 1,
    "& > .MuiInputBase-input": {
      height: '22px',
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "22px",
      padding: 0,
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#323440",
      opacity: 1,
    },
  },
};

export default styles;
